/**
 * @deprecated - This property is being removed in V6+, February 2025, please use `border` from `smartsheet/design-tokens`.
 */
export const borderRadius = () => 4;
//# sourceMappingURL=borders.js.map